import React from 'react';

export default function Contact() {
	return (
		<React.Fragment>
			<h1> Contact </h1>
			<p>
				Mail:{' '}
				<a href="mailto:contact@djaconitum.com">
					contact@djaconitum.com
				</a>
				<br />
				Instagram:{' '}
				<a
					href="https://www.instagram.com/djaconitum"
					target="_blank"
					rel="noreferrer">
					@djaconitum
				</a>
				<br />
				Twitter:{' '}
				<a
					href="https://twitter.com/djaconitum"
					target="_blank"
					rel="noreferrer">
					@djaconitum
				</a>
			</p>
		</React.Fragment>
	);
}
